<template>
  <div>
    <v-dialog persistent v-model="dialog" width="800px">
      <v-card width="800px">
        <v-card-title style="background: #455a64; color: white">
          <span class="overline font-weight-black;">CAD依頼添付資料</span
          ><v-spacer /><v-icon color="white" @click="closeToggleDialogAttachment()"
            >mdi-close</v-icon
          >
        </v-card-title>

        <v-container class="mainTable" v-if="editMode">
          <v-simple-table flat>
            <thead></thead>
            <tbody>
              <tr v-for="(item, index) in previousAttachmentFiles" :key="index">
                <td width="15%">{{ item.att_column_name }}</td>
                <td width="45%">{{ item.filename }}</td>
                <td width="10%" class="text-center" v-if="item.no_of_pages != 0">
                  {{ item.no_of_pages }}
                </td>
                <td width="10%" class="text-center" v-else>N/A</td>
                <td width="20%">
                  <v-icon color="primary" @click="viewFile(item.id)"
                    >mdi-file-find</v-icon
                  >
                  <v-icon color="success" @click="downLoadFile(item.id, 'single')"
                    >mdi-download-outline</v-icon
                  >
                  <v-icon color="error" @click="deleteFile(item.id, item)"
                    >mdi-trash-can</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-spacer />
          <v-spacer />
          <v-card-actions>
            <v-btn outlined dense color="primary" @click="addNewAttachment = true"
              >Add Attachment</v-btn
            >
          </v-card-actions>
        </v-container>

        <v-container v-if="addNewAttachment || !editMode">
          <!-- <v-card-text>
          <v-container>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              chips
              multiple
              clearable
              v-model="fileAttachments.attachmentFile1"
              density="compact"
              label="CAD/配置図（PDF/iCAD DBデータ）"
              @change="fileChange(fileAttachments.attachmentFile1, 'CAD', 'files')"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              clearable
              chips
              multiple
              v-model="fileAttachments.attachmentFile2"
              density="compact"
              label="現況図（DXF）"
              @change="fileChange(fileAttachments.attachmentFile2, '現況図（CADデータ）', 'files1')"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              multiple
              chips
              v-model="fileAttachments.attachmentFile3"
              @change="fileChange(fileAttachments.attachmentFile3, '仕様検討ツール', 'files2')"
              density="compact"
              label="仕様検討ツール（PDF）"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              chips
              multiple
              v-model="fileAttachments.attachmentFile4"
              @change="fileChange(fileAttachments.attachmentFile4, '区画図', 'files3')"
              density="compact"
              label="区画図(SWDI※iCADから出⼒)"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              multiple
              chips
              v-model="fileAttachments.attachmentFile5"
              @change="fileChange(fileAttachments.attachmentFile5, '吊り上げ重量制限', 'files4')"
              density="compact"
              label="吊り上げ重量制限（PDF）"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              multiple
              chips
              v-model="fileAttachments.attachmentFile6"
              @change="fileChange(fileAttachments.attachmentFile6, '電気図面/提案電気図面依頼書', 'files5')"
              density="compact"
              label="電気図面/提案電気図面依頼書（PDF）"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              multiple
              chips
              v-model="fileAttachments.attachmentFile7"
              @change="fileChange(fileAttachments.attachmentFile7, '電気図面連絡表', 'files6')"
              density="compact"
              label="電気図面連絡表（PDF）"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              multiple
              chips
              v-model="fileAttachments.attachmentFile8"
              @change="fileChange(fileAttachments.attachmentFile8, '施工連絡表', 'files7')"
              density="compact"
              label=" 施工連絡表（PDF）"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              chips
              multiple
              v-model="fileAttachments.attachmentFile9"
              @change="fileChange(fileAttachments.attachmentFile9, '営業本部回答票', 'files8')"
              density="compact"
              label="営業本部回答票（PDF）"
            ></v-file-input>
            <v-file-input
              prepend-icon=""
              outlined
              dense
              chips
              multiple
              v-model="fileAttachments.attachmentFile10"
              @change="fileChange(fileAttachments.attachmentFile10, 'その他', 'files9')"
              density="compact"
              label="その他（PDF）"
            ></v-file-input>
          </v-container>
          <div style="text-align: right; justify-content: space-between">
            <v-btn dark color="red" class="mb-4" @click="toggleDialogAttachmentForm(false)"
              ><span class="overline font-weight-black;">キャンセル</span></v-btn
            >
            <v-btn overline color="success" class="mb-4" dark
              ><span
                class="overline font-weight-black;"
                @click="savingAttachments()"
                >保存</span
              >
            </v-btn>
          </div>
          </v-card-text> -->

          <!-- dynamic -->
          <v-card-text>
            <div class="ml-5">
              <v-row
                no-gutters
                class="ml-2"
                @drop="getIndexForDrag(i)"
                @drop.prevent="addDropFile"
                @dragover.prevent
                v-for="(items, i) in rowNames"
                :key="i"
              >
                <v-col cols="11">
                  <v-file-input
                    v-model="fileAttachments.attachmentFile[i]"
                    @change="manualAttach(i)"
                    @click:clear="clearableIcon(i)"
                    outlined
                    dense
                    clearable
                    show-size
                    counter
                    :label="items.text"
                    multiple
                  >
                    <!-- max-length="20" -->
                  <v-icon slot="append" color="primary" @click="previewFile(fileAttachments.attachmentFile[i])"
                    v-if="isFileAttached[i] != null && fileAttachments.attachmentFile[i].length == 1">mdi-eye</v-icon>
                  </v-file-input>
                  <ul class="ml-3">
                    <li
                      v-for="(file, index) in fileAttachments.attachmentFile[i]"
                      :key="index"
                    >
                      {{ file.name }}
                      <v-icon color="primary" @click="previewMultipleFile(fileAttachments.attachmentFile[i], index)" v-if="fileAttachments.attachmentFile[i] != null">
                        mdi-eye</v-icon>
                      <!-- <v-icon @click="deleteMultipleFile(fileAttachments.attachmentFile[i])" color="#F44336">mdi-delete</v-icon> -->
                    </li>
                  </ul>

                  <!-- ****************************************************************************** -->
                  <!--                        PREVIOUS ATTACHMENTS                                    -->
                  <!-- ****************************************************************************** -->
                  <!-- {{copyPreviousAttachment}} -->
                  <span v-for="(att, index) in copyPreviousAttachment" :key="index">
                    <div style="display: flex; align-items: center;">
                      <v-checkbox
                        v-model="previousAttCheckbox"
                        v-if="att.att_column_name == items.value"
                        :value="att"
                      >
                        <template v-slot:label>
                          <div>
                            <b>{{ att.filename }}</b>
                          </div>
                        </template>
                      </v-checkbox>
                      <v-icon v-if="att.att_column_name == items.value" color="primary" class="ml-2" @click="viewFile(att.id)">
                        mdi-file-find
                      </v-icon>
                    </div>
                  </span>
                </v-col>
              </v-row>
            </div>
            <div style="text-align: right; justify-content: space-between">
              <v-btn
                dark
                color="red"
                class="mb-4"
                @click="closeToggleDialogAttachment()"
                ><span class="overline font-weight-black;">キャンセル</span></v-btn
              >
              <v-btn overline color="success" class="mb-4" dark
                ><span class="overline font-weight-black;" @click="savingAttachments()"
                  >保存</span
                >
              </v-btn>
            </div>
          </v-card-text>
          <!-- dynamic -->
        </v-container>
      </v-card>
    </v-dialog>

    <v-snackbar
      class="custom-snackbar"
      v-model="snackbar.show"
      :color="snackbar.color"
      centered
      :timeout="timeout"
      elevation="5"
      min-width="0"
      transition="scroll-y-transition"
    >
      <v-icon>{{ snackbar.icon }}</v-icon>
      <strong>{{ snackbar.message }}</strong>
    </v-snackbar>
  </div>
</template>
<script>
import { PDFDocument } from "pdf-lib";
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  props: {
    dialog: Boolean,
  },

  data: () => ({
    snackbar: {
      show: false,
      message: null,
      color: null,
    },
    timeout: 2000,
    previousAttCheckbox: [],

    isBlinking: true,
    addNewAttachment: false,
    attachmentDialog: false,
    previousAttachment: false,
    // previousAttachmentFiles : [],
    rowNames: [
      {
        value: "CAD",
        text: "CAD/配置図（PDF/iCAD DBデータ）",
      }, //CAD/配置図
      {
        value: "現況図（CADデータ）",
        text: "現況図（DXF）",
      }, //現況図（CADデータ）
      // {
      //   value: '屋外配管経路図',
      //   text: '屋外配管経路図  (PDF)'
      // }, // 屋外配管経路図  (PDF)
      {
        value: "仕様検討ツール",
        text: "仕様検討ツール（PDF）",
      }, //仕様検討ツール
      {
        value: "区画図",
        // text: "区画図（PDF/iCAD DB/iCAD SWDI）",
        text: "区画図(SWDI※iCADから出⼒)",
      }, //区画図
      {
        value: "吊り上げ重量制限",
        text: "吊り上げ重量制限（PDF）",
      }, //吊り上げ重量制限
      {
        value: "電気図面/提案電気図面依頼書",
        text: "電気図面/提案電気図面依頼書（PDF）",
      }, //電気図面/提案電気図面依頼書
      {
        value: "電気図面連絡表",
        text: "電気図面連絡表（PDF）",
      }, //電気図面連絡表
      {
        value: "施工連絡表",
        text: "施工連絡表（PDF）",
      }, //施工連絡表
      {
        value: "営業本部回答票",
        text: "営業本部回答票（PDF）",
      }, //営業本部回答票
      {
        value: "その他",
        text: "その他（PDF）",
      }, //その他"
    ],
    fileAttachments: {
      attachmentFile: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        // [],
      ],
    },
    tempFileAttachments: {
      attachmentFile: [[], [], [], [], [], [], [], [], [], []],
    },
    // fileAttachments: {
    //   attachmentFile1: [], //CAD/配置図
    //   attachmentFile2: [], //現況図（CADデータ）
    //   attachmentFile3: [], //仕様検討ツール
    //   attachmentFile4: [], //区画図
    //   attachmentFile5: [], //吊り上げ重量制限
    //   attachmentFile6: [], //電気図面/提案電気図面依頼書
    //   attachmentFile7: [], //電気図面連絡表
    //   attachmentFile8: [], //施工連絡表
    //   attachmentFile9: [], //営業本部回答票
    //   attachmentFile10: [], //その他"
    // },
    files0: [],
    files: [],
    files1: [],
    files2: [],
    files3: [],
    files4: [],
    files5: [],
    files6: [],
    files7: [],
    files8: [],
    files9: [],
    categories: [
      "CAD",
      "現況図（CADデータ）",
      "仕様検討ツール",
      "区画図",
      "吊り上げ重量制限",
      "電気図面/提案電気図面依頼書",
      "電気図面連絡表",
      "施工連絡表",
      "営業本部回答票",
      "その他",
    ],
    previews: [],
    errorImage: "url of an image to use to indicate an error",
    selectedFiles: null,
    isDragging: false,
    rowIndex: null,
    exceedFileSize: false,
    isFileAttached: [],
    // currentFileForDelete : null,
    currentIndexForDelete: [],
  }),
  computed: {
    ...mapState([
      "attachments",
      "cadRequestRevisionContent",
      "editMode",
      "editCadRequestRevisionContent",
      "previousAttachmentFiles",
      "editMode",
      "hrdprocessMode",
      "copyPreviousAttachment",
      "additionalAtachments",
      "electrical_request",
    ]),
  },
  methods: {
    previewFile(files){
      // PREVIEW FOR SINGLE FILE ATTACHMENT
      if (files && files.length > 0) {
        files.forEach((file, index) => {
          // Perform file type check
          if (file.type.startsWith('image/')) {
            // Open a new window/tab to display the image
            const previewWindow = window.open('', `_blank_${index}`);
            previewWindow.document.write(`<img src="${URL.createObjectURL(file)}" alt="File Preview">`);
          } else if (file.type === 'application/pdf') {
            // Open a new window/tab to display the PDF
            const previewWindow = window.open('', `_blank_${index}`);
            previewWindow.document.write(`<embed src="${URL.createObjectURL(file)}" type="application/pdf" width="100%" height="100%"/>`);
          } else {
            // Handle other file types or show an error message
            alert(`Preview not supported for file ${index + 1} with type ${file.type}.`);
          }
        });
      } else {
        // No file selected, show an error message or handle accordingly
        alert('Please select files for preview.');
      }
    },

    previewMultipleFile(files, index) {
      // console.log(index,'index')
      // PREVIEW FOR MULTIPLE FILE
      if (files && files.length > 0 && index >= 0 && index < files.length) {
        const file = files[index];
        const previewWindow = window.open('', '_blank');
        
        if (file.type.startsWith('image/')) {
          // For image files
          previewWindow.document.write(`<img src="${URL.createObjectURL(file)}" alt="File Preview">`);
        } else if (file.type === 'application/pdf') {
          // For PDF files
          previewWindow.document.write(`<embed src="${URL.createObjectURL(file)}" type="application/pdf" width="100%" height="100%"/>`);
        } else {
          // Handle other file types or show an error message
          previewWindow.document.write(`<p>Preview not supported for this file type (${file.type}).</p>`);
        }
      } else {
        // Invalid index or no file selected, show an error message or handle accordingly
        alert('Invalid index or no file selected for preview.');
      }
      // PREVIEW FOR SINGLE FILE
      // if (files && files.length > 0) {
      //   const file = files[0]; // Assuming you are handling a single file for preview
      //   // Perform file type check
      //   if (file.type.startsWith('image/')) {
      //     // Open a new window/tab to display the image
      //     const previewWindow = window.open('', '_blank');
      //     previewWindow.document.write(`<img src="${URL.createObjectURL(file)}" alt="File Preview">`);
      //   } else if (file.type === 'application/pdf') {
      //     // Open a new window/tab to display the PDF
      //     const previewWindow = window.open('', '_blank');
      //     previewWindow.document.write(`<embed src="${URL.createObjectURL(file)}" type="application/pdf" width="100%" height="100%"/>`);
      //   } else {
      //     // Handle other file types or show an error message
      //     alert('Preview not supported for this file type.');
      //   }
      // } else {
      //   // No file selected, show an error message or handle accordingly
      //   alert('Please select a file for preview.');
      // }
    },

    // deleteMultipleFile(items){  
    //   let indexFile = this.fileAttachments.attachmentFile.indexOf(items)
    
    //   console.log(indexFile,'indexFile')
    //   console.log(items,'items')
    // },

    async clearTest(){
      // this.fileAttachments.attachmentFile = []
      this.tempFileAttachments.attachmentFile[0] = [];
      // this.tempFileAttachments= {
      //   attachmentFile: [
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     // [],
      //   ],
      // }
      // this.fileAttachments= {
      //   attachmentFile: [
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     [],
      //     // [],
      //   ],
      // }
      // this.$store.state.cadRequestRevisionContent.request_attach_from = 0;
    },

    clearableIcon(val) {
      if (this.fileAttachments.attachmentFile[val][0]) {
        // for (let x = this.tempoFiles.files[val].length - 1; x >= 0; x--) {
        //   this.fileAttachments.attachmentFile[val].unshift(this.tempoFiles.files[val][x]);
        // }
        // return;
        //For clear button on file input
        // if(file.length>1){
        this.tempFileAttachments.attachmentFile[val] = [];
        this.fileAttachments.attachmentFile[val] = [];

        return this.$forceUpdate();
        // }
        // if(file.length==0)
        //  return
      }

    },

    async manualAttach(index) {
      const categories = this.categories;
      let isError = false; // Flag to track errors
      // this.fileAttachments.attachmentFile[index] = [];
      for (
        let x = this.tempFileAttachments.attachmentFile[index].length - 1;
        x >= 0;
        x--
      ) {
        this.fileAttachments.attachmentFile[index].unshift(
          this.tempFileAttachments.attachmentFile[index][x]
        );
      }
      if (this.fileAttachments.attachmentFile[index][0]) {
        // if (this.tempFileAttachments.attachmentFile[index]) {
        //   for (let x = this.tempFileAttachments.attachmentFile[index].length - 1; x >= 0; x--) {
        //     this.fileAttachments.attachmentFile[index].unshift(this.tempFileAttachments.attachmentFile[index][x]);
        //   }
        // }

        this.tempFileAttachments.attachmentFile[index] = [];
        for (let x = 0; x < this.fileAttachments.attachmentFile[index].length; x++) {
          this.fileAttachments.attachmentFile[index][x].col = categories[index];
          this.tempFileAttachments.attachmentFile[index].push(
            this.fileAttachments.attachmentFile[index][x]
          );
        }
      }

      this.isFileAttached[index] = Boolean(this.fileAttachments.attachmentFile[index])
      await this.fileNameLength(index);
      await this.fileDetails();
    },

    fileNameLength(index){
      try {
        const longFileNames = [];
        // NOTE - Titignan nya yung files na ininput kung more than 50 character tapos i-pupush nya sa array
        this.fileAttachments.attachmentFile.forEach((sizes) => {
          if (sizes.length > 0) {
            sizes.forEach((file) => {
              const swdiFile = file.name.endsWith('.swdi'); // Check if file is a SWDI
              const swdiFileName = file.col === '区画図';
              if (file.name.length > 50) {
                longFileNames.push(file.name);
              }

              // SWDI 
              if(!swdiFile && swdiFileName){
                Swal.fire({
                        html: '<div style="text-align: center;font-size:24px;font-weight:bold;">' +
                            '区画図はswdi形式のデータを添付してください。<br>' +
                            'swdi形式以外の区画図データにて構造事前検討は対応不可となります。<br>',
                        icon: 'warning',
                        width : 730,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        })
                  this.fileAttachments.attachmentFile[index] = [];
                  this.tempFileAttachments.attachmentFile[index] = [];
              }
              // END

            });
          }
        });
        // NOTE - After ma-push gagawa ng bagong array tapos i-jojoin yung file sa isang string
        if (longFileNames.length > 0) {
          const filesList = longFileNames.map((name) => `"${name}"`).join(", ");
          Swal.fire({
                title: 'File Names Too Long',
                html: '<div style="text-align: center;font-size:20px;">' +
                    `The following files have names longer than 50 characters: <b style="font-size:23px;">${filesList}</b>.<br>` + 
                    'Please shorten the file names.',
                icon: 'warning',
                width : 650,
          })
          this.fileAttachments.attachmentFile[index] = [];
          this.tempFileAttachments.attachmentFile[index] = [];
        }
      } catch (error) {
        console.log(error, "error");
      }
    },

    fileDetails() {
      try {
        this.exceedFileSize = false;
        let totalSize = 0;
        this.fileAttachments.attachmentFile.forEach((element) => {
          let a = 0;

          if (element.length > 0) {
            // console.log(element)
            a = element.reduce((total, item) => {
              if (item.size <= 0) return;
              total += item.size;
              return total;
            }, 0);
            // console.log(a, 'a')
          }
          totalSize += a;
        });
        // console.log(totalSize, 'size')

        if (totalSize > 150000000) {
          // alert('file exceeded 150MB')
          Swal.fire({
            icon: "error",
            title: "File attached exceeds 150 MB!",
            text: "Please attach smaller size of files.",
          });
          this.exceedFileSize = true;
          return false;
        } else {
          this.fileAttachments.attachmentFile.forEach((element) => {
            // console.log(element,'elemeeeental')
            if (element.length > 0) {
              const readFile = (file) => {
                return new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(reader.result);
                  reader.onerror = (error) => reject(error);
                  reader.readAsArrayBuffer(file);
                });
              };

              const getNumPages = async (file) => {
                const arrayBuffer = await readFile(file);
                const pdf = await PDFDocument.load(arrayBuffer);
                return pdf.getPages();
              };

              this.files = [];
              element.forEach(async (item, index) => {
                let numPages = 0;
                let splitFile = item.name.split(".");
                // console.log(splitFile[splitFile.length - 1])

                if (
                  splitFile[splitFile.length - 1] == "pdf" ||
                  splitFile[splitFile.length - 1] == "PDF"
                ) {
                  numPages = await getNumPages(item);
                  numPages = numPages.length;
                }
                const reader = new FileReader();
                reader.readAsDataURL(item);
                reader.onloadend = () => {
                  this.files.push({
                    data: reader.result,
                    name: item.name,
                    column_name: item.col,
                    page_count: numPages,
                  });
                };
              });
              // console.log(this.files, 'filesssss')
            }
          });
        }
      } catch (error) {
        console.log(error, "error");
      }
    },



    getIndexForDrag(index) {
      this.rowIndex = index;
    },
    async addDropFile(e) {
      try {
        let files = Array.from(e.dataTransfer.files);

        for (const file of files) {
          // file.forEach(individual => {
          try {
            // console.log(file, 'indi')
            if (file.size == 0) {
              alert("Error file : " + file.name);
              return;
            }
            file.col = this.categories[this.rowIndex];
            this.fileAttachments.attachmentFile[this.rowIndex].push(file);
          } catch (parseError) {
            console.error(parseError, "PDF parsing error");
            // Handle corrupted PDF error
            alert("PDF parsing error:", parseError.message);
            return;
            // You can display a user-friendly message or take any other appropriate action
          }
          // });
        }
        // console.log(this.fileAttachments.attachmentFile, 'fileeeeeeeeeeeeeee')
        await this.fileDetails();
      } catch (error) {
        console.error(error, "general error");
        // Handle other types of errors
        alert("An error occurred:", error.message);
      }
    },

    handleFileChange(event) {
      this.selectedFiles = [...event];

      // Perform any additional actions with the selected file here
    },
    handleDragEnter(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    handleDragLeave(event) {
      event.preventDefault();
      this.isDragging = false;
    },
    handleDragOver(event) {
      event.preventDefault();
    },
    handleDrop(event, col) {
      event.preventDefault();
      this.isDragging = false;

      if (event.dataTransfer.files.length > 0) {
        this.fileAttachments = [...event.dataTransfer.files];
        // console.log(event, 'event')

        // Perform any additional actions with the dropped file here
      }
    },
    deleteFile(id, item) {
      axios({
        method: "POST",
        url: "api/delete_attachment",
        data: {
          id: id,
          details: item,
        },
      }).then(({ data }) => {
        this.$store.state.previousAttachmentFiles = data.attachments.filter((r) => {
          let type = r.filename.split(".");
          r.fileType = type[type.length - 1];
          return r;
        });
        // this.$emit('getCadActualData');
        this.$store.state.editCadRequestRevisionContent.attachments = this.previousAttachment;
        // console.log(this.$store.state.previousAttachmentFiles, 'this.$store.state.previousAttachmentFiles')
      });
    },
    downLoadFile(id, type) {
      // axios.get(`download_file/${id}/${type}`,)
      // axios({
      //     method:'get',
      //     url:`download_file/${id}/${type}`,
      //     headers: {
      //         'Content-Type': 'application/json'
      //     }
      // }).then(()=>{
      window.open(`download_file/${id}/${type}`, "_blank");
      // })
    },
    viewFile(id) {
      axios({
        method: "get",
        url: `open_file/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      }).then(() => {
        // console.log(data)
        window.open(`open_file/${id}`, "_blank").focus();
      });
    },
    fileChange(tempVariable, col, vmod) {
      this[vmod] = [];
      if (tempVariable) {
        // let a = tempVariable.filter((file) => file.size > 104857600)
        let a = tempVariable.reduce((total, item) => {
          total += item.size;
          return total;
        }, 0);
        // console.log(a)
        if (a > 524288000) {
          alert("file exceeded 500 mb");
          return false;
        }

        const readFile = (file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
          });
        };

        const getNumPages = async (file) => {
          const arrayBuffer = await readFile(file);
          const pdf = await PDFDocument.load(arrayBuffer);
          return pdf.getPages();
        };

        tempVariable.forEach(async (item) => {
          let numPages = 0;
          let splitFile = item.name.split(".");
          if (
            splitFile[splitFile.length - 1] == "pdf" ||
            splitFile[splitFile.length - 1] == "PDF"
          ) {
            numPages = await getNumPages(item);
            numPages = numPages.length;
          }
          // console.log(numPages.length, 'numPages');
          const reader = new FileReader();
          reader.readAsDataURL(item);
          // console.log(item)
          // if (tempVariable == "tempCsvFileImportBalcony") {
          reader.onloadend = () => {
            // const count = reader.result.match("/\/Page\W/");
            //     console.log(reader.result);
            this[vmod].push({
              data: reader.result,
              name: item.name,
              column_name: col,
              page_count: numPages,
            });
          };

          // reader.readAsBinaryString(item);
          // reader.onloadend = () => {
          //     const count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;
          //     console.log('Number of Pages:', count);
          // }
          // }
        });
      }
    },
    toggleDialogAttachmentForm(value) {
      this.$emit("toggleDialogAttachmentForm", value);
    },
    closeToggleDialogAttachment(){
      if(!this.editMode){
        this.previousAttCheckbox = []
        this.$emit('closeToggleDialogAttachment', null)
        this.toggleDialogAttachmentForm(false)
      } else {
        this.toggleDialogAttachmentForm(false)
      }
    },
    toggleDialogPreviousAttachmentForm(value) {
      this.$emit("toggleDialogPreviousAttachmentForm", value);
    },
    openAttachmentDialog() {
      this.attachmentDialog = true;
    },
    savingAttachments() {
      if (this.exceedFileSize) {
        Swal.fire({
          icon: "error",
          title: "File attached exceeds 150 MB!",
          text: "Please attach smaller size of files.",
        });
        this.exceedFileSize = true;
        return false;
      } else {
        // IF PREVIOUS ATTACHMENT WITH DATA AND SITE N
        // this.$store.state.previousAttachmentFiles.filter((v) => {
        //   if(v.att_column_name == '現況図（CADデータ）' && this.$store.state.cadRequestRevisionContent.site_layout == '新規データN') {
        //       this.toggleDialogAttachmentForm(false);
        //   }
        // })
        // const lastFile = [...this.files0, ...this.files1, ...this.files2, ...this.files3, ...this.files4, ...this.files5, ...this.files6, ...this.files7, ...this.files8, ...this.files9];
        // const lastFile = [...this.files, ...this.files1, ...this.files2, ...this.files3, ...this.files4, ...this.files5, ...this.files6, ...this.files7, ...this.files8, ...this.files9];
        this.$store.state.attachments = this.files;
        // console.log(this.$store.state.attachments,'attachmentssssss')
        this.$store.state.additionalAtachments = this.previousAttCheckbox;
        // console.log(this.$store.state.additionalAtachments, 'this.$store.state.additionalAtachments')
        if (this.$store.state.editMode) {
          this.$store.state.editCadRequestRevisionContent.request_attach_from =
            this.$store.state.attachments.length > 0 ||
            this.$store.state.additionalAtachments.length > 0 ? 1 : 0;
          this.toggleDialogAttachmentForm(false);
        } else {
          this.$store.state.cadRequestRevisionContent.request_attach_from =
            this.files.length > 0 ? 1 : 0;
          this.toggleDialogAttachmentForm(false);
        }
        this.$store.state.getPrevAttach = this.previousAttCheckbox.map((res) => {
          return res.att_column_name;
        })
        // console.log(this.$store.state.getPrevAttach,'this.$store.state.getPrevAttachssss')

        // NOTE : TRAPPPING FOR OKUGAI EMERU
        // if(this.$store.state.cadRequestRevisionContent.site_boss == '2' || this.$store.state.cadRequestRevisionContent.new_site_boss == '2' && this.fileAttachments.attachmentFile[2] == '') {
        //   this.snackbar = {
        //                 message : 'Please Insert File in 屋外配管経路図（PDF）',
        //                 color : 'blue darken-2',
        //                 icon: 'mdi-information',
        //                 show: true
        //               }
        //   this.toggleDialogAttachmentForm(true);
        //   // console.log(this.fileAttachments.attachmentFile[6],'this.fileAttachments')
        // } else {
        //   this.toggleDialogAttachmentForm(false);
        // }

        // NOTE : TRAPPING FOR INSERT FILE IN ELECTRICAL DRAWING
        // if(this.$store.state.getDrawingRequest?.length) {
        //   this.$store.state.getDrawingRequest.forEach(element => {
        //   // console.log(element,'elemento')
        //     if(element == '2' && this.fileAttachments.attachmentFile[7] == '') {
        //       this.snackbar = {
        //                   message : 'Please Insert File in 電気図面連絡表（PDF）',
        //                   color : 'blue darken-2',
        //                   icon: 'mdi-information',
        //                   show: true
        //                 }
        //       this.toggleDialogAttachmentForm(true);
        //       // console.log(this.fileAttachments.attachmentFile[6],'this.fileAttachments')
        //     } else {
        //       this.toggleDialogAttachmentForm(false);
        //     }
        //   })
        // }

        // NOTE : TRAPPING FOR INSERT FILE DON'T DELETE!
        // ADD ATTACHMENT IF SITE LAYOUT IS 新規データN
        // if(this.$store.state.cadRequestRevisionContent.site_layout == '新規データN' && this.files1 == ''){
        //     // console.log(this.$store.state.cadRequestRevisionContent,'site')
        //   this.snackbar = {
        //               message : 'Please Insert File in 現況図（CADデータ）',
        //               color : 'blue darken-2',
        //               icon: 'mdi-information',
        //               show: true
        //           }
        //   this.toggleDialogAttachmentForm(true);
        // }else if(this.$store.state.cadRequestRevisionContent.site_layout == '新規データN' && this.files1 != ''){
        //     this.toggleDialogAttachmentForm(false);
        // } else if(this.$store.state.cadRequestRevisionContent.site_layout != '新規データN' && this.files1 != '') {
        //   this.toggleDialogAttachmentForm(false);
        // } else if(this.$store.state.cadRequestRevisionContent.site_layout != '新規データN' && this.files1 == '') {
        //   this.toggleDialogAttachmentForm(false);
        // }

        // EDIT ATTACHMENT IF SITE LAYOUT IS 新規データN
        // if(this.$store.state.editMode){
        //   if(this.$store.state.editCadRequestRevisionContent.site_layout == '新規データN' && this.files1 == '') {
        //     this.snackbar = {
        //               message : 'Please Insert File in 現況図（CADデータ）',
        //               color : 'blue darken-2',
        //               icon : 'mdi-information',
        //               show : true
        //     }
        //     this.toggleDialogAttachmentForm(true);
        //   } else if(this.$store.state.editCadRequestRevisionContent.site_layout == '新規データN' && this.files1 != ''){
        //     this.toggleDialogAttachmentForm(false);
        //   } else if(this.$store.state.editCadRequestRevisionContent.site_layout != '新規データN' && this.files1 != '') {
        //     this.toggleDialogAttachmentForm(false);
        //   } else if(this.$store.state.editCadRequestRevisionContent.site_layout != '新規データN' && this.files1 == '') {
        //     this.toggleDialogAttachmentForm(false);
        //   }
        // }
      }
    },
  },
  watch: {
    // previousAttCheckbox(val){
    //   console.log(val, 'check')
    // },
    // '$store.state.previousAttachmentFiles'(val){
    //   // console.log(val, 'att')
    // },
    // '$store.state.CadRequestRevisionContent'(val){
    //   // this.$store.state.cadRequestRevisionContent = val;
    //   // console.log(val)
    // }
  },

  mounted() {
    this.$store.state.getFileAttachment = this.fileAttachments.attachmentFile;
    this.$store.state.getPrevAttach = this.previousAttCheckbox.map((res) => {
        return res.att_column_name;
      })
  },
};
</script>
<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
  text-align: center;
}

.drop-zone.drag-over {
  border-color: #007bff;
}
.custom-snackbar {
  margin-top: 25%;
}
</style>
